import { useEffect } from 'react';
import { useMutation } from '@apollo/client/react/hooks';
import { gql } from '@yi/core';
import { AdyenError } from '@yi/core/src/custom-errors';

import { notifyBugsnag, nr } from '~/common';
import { useCurrentUser } from '~/src/common/user';

import { useRunOnlyOnce } from './useRunOnlyOnce';

export const useEnsureGaiaAccountExists = () => {
  const { currentUser, loading: currentUserLoading, refetch } = useCurrentUser();

  const [createGaiaAccount, { loading: accountCreatedLoading, error: accountCreatedError }] =
    useMutation<gql.typesClient.Mutate_CreateGaiaAccount, null>(gql.Mutate_CreateGaiaAccount, {
      onCompleted: d => {
        const { error } = d.createGaiaAccount;
        if (error) {
          notifyBugsnag(error);
          nr.noticeError(new AdyenError(error), { user_id: currentUser?.id || '' });
        }
      },
      onError: e => {
        notifyBugsnag(e);
        nr.noticeError(new AdyenError(e), { user_id: currentUser?.id || '' });
      },
    });

  const createAccountOnce = useRunOnlyOnce(async () => {
    const res = await createGaiaAccount();
    if (res?.data?.createGaiaAccount?.success) refetch();
  }, [currentUser]);

  useEffect(() => {
    if (currentUser && !currentUser.gaia_id) createAccountOnce();
  }, [currentUser, createAccountOnce]);

  const gaiaId = currentUser?.gaia_id;

  return {
    loading: accountCreatedLoading || currentUserLoading,
    error: !currentUserLoading && !gaiaId && accountCreatedError,
    exists: !!gaiaId,
  };
};
